import VBreadcrumbs from './VBreadcrumbs'
import VBreadcrumbsItem from './VBreadcrumbsItem'

export default {
  VBreadcrumbs,
  VBreadcrumbsItem
}



// WEBPACK FOOTER //
// ./src/components/breadcrumbs/index.js